import { useEffect, useState } from 'react';

import { sectionMappings } from '../layouts/front/sectionHelpers.js';

export const useActiveSectionSearch = (section: string) => {
  const [activeSection, setActiveSection] = useState<string>(section);

  useEffect(() => {
    const lastActive = document.referrer.split('/').pop();
    if (lastActive && Object.keys(sectionMappings).indexOf(lastActive) >= 0) {
      setActiveSection(lastActive);
    } else {
      setActiveSection(section || 'mat-og-drikke');
    }
  }, []);

  return { activeSection, setActiveSection };
};
